// \nを<br>に変換する
export const replaceKaigyo = function (message: string) {
  if (!message) return "";
  return message.replace(/\n|\\n/g, "<br>");
};
